/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ConfigurazioneFormTranslatedDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetTipoPraticaConfigurazioneFormTranslatedRequestParams {
    idTipoPratica: string;
}


export interface TipoPraticaConfigurazioneFormTradottoOperatoreServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Ritorna il template del form cittadino del bando gia\&#39; tradotto dal resolver ($dynamic espanso, opzioni dei SELECT popolate inline). Read-only, audience SUPERADMIN | OP_COMUNE | OP_PRATICA con capability CONSULTAZIONE.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/configurazione-form-translated
* @param requestParameters
     */
    getTipoPraticaConfigurazioneFormTranslated(requestParameters: GetTipoPraticaConfigurazioneFormTranslatedRequestParams, extraHttpRequestParams?: any): Observable<ConfigurazioneFormTranslatedDTO>;

}
